import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useState } from 'react';
import * as ReportGenerationStore from '../../../../../../redux/reportGeneration';

const usePublishReport = () => {
  const dispatch = useDispatch();
  const [isReportPublished, setIsReportPublished] = useState(false);
  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext);
  const reportOptions = useSelector(ReportGenerationStore.selectors.getReportOptions);
  const {
    queuePublishReport: { errors, isLoading },
  } = useSelector(ReportGenerationStore.selectors.getAsyncStatuses);

  const publishReport = useCallback(async () => {
    dispatch(ReportGenerationStore.actions.queuePublishReport(reportContext, reportOptions));
    setIsReportPublished(true);
  }, [dispatch, reportContext, reportOptions]);

  return {
    publishReport,
    errors: errors || [],
    isLoading,
    isPublished: isReportPublished,
  };
};

export default usePublishReport;
